import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'zaver-basic-button',
  templateUrl: './basic-button.component.html',
  styleUrls: ['./basic-button.component.scss'],
})
export class BasicButtonComponent implements OnInit {
  @Input() text: string = '';
  @Input() icon?: string;
  @Input() iconName?: string;
  @Input() iconPosition: 'leading' | 'trailing' = 'leading';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() primary: boolean = false;
  @Input() secondary: boolean = false;
  @Input() lg: boolean = false;
  @Input() md: boolean = false;
  @Input() sm: boolean = false;
  @Input() onClick?: () => void;

  @ViewChild('basicButton') basicButton!: ElementRef<HTMLButtonElement>;

  isPressed: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  handleClick(event: MouseEvent) {
    if (this.onClick && !this.disabled && !this.loading) {
      this.onClick();
    }
  }

  handleInteraction(event: MouseEvent | KeyboardEvent): void {
    const isMouseDown = event.type === 'mousedown';
    const isEnterKeyDown =
      event.type === 'keydown' && (event as KeyboardEvent).key === 'Enter';
    const isUnpressed = event.type === 'mouseup' || event.type === 'keyup';

    if (isMouseDown || isEnterKeyDown) {
      this.isPressed = true;
    } else if (isUnpressed) {
      this.isPressed = false;
    }
  }
}

export type BasicButtonEvents = {
  onClick?: (event: MouseEvent) => void;
};

export type BasicButtonSize = {
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
};

export type BasicButtonTypes = {
  primary?: boolean;
  secondary?: boolean;
};

export type BasicButtonState = {
  hover?: boolean;
  focused?: boolean;
  loading?: boolean;
  disabled?: boolean;
};

export type BasicButtonProps = {
  icon?: string; // Assuming icon is a string representing the icon name or path
  iconName?: string;
  iconPosition?: 'leading' | 'trailing';
} & BasicButtonEvents &
  BasicButtonSize &
  BasicButtonTypes &
  BasicButtonState;
